import { isNull } from 'lodash/fp';

export const hasPermission = (permissions: number[], userPermissions: number[] | null) => {
    if (isNull(userPermissions) || !userPermissions) {
        return false;
    }
    return permissions.every(permission => userPermissions.includes(permission));
};
